import { render, staticRenderFns } from "./TopNewsNormal.vue?vue&type=template&id=3243be0b&scoped=true&"
import script from "./TopNewsNormal.vue?vue&type=script&lang=js&"
export * from "./TopNewsNormal.vue?vue&type=script&lang=js&"
import style0 from "./TopNewsNormal.vue?vue&type=style&index=0&id=3243be0b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3243be0b",
  null
  
)

export default component.exports